import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { LeadsBrowserStore } from './leads-browser.store';

const LeadsBrowserContext = React.createContext<LeadsBrowserStore | null>(null);

export const LeadsBrowserProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<LeadsBrowserStore>(() => new LeadsBrowserStore(navigate));

   return <LeadsBrowserContext.Provider value={store}>{children}</LeadsBrowserContext.Provider>;
};

export const useLeadsBrowser = () => {
   const ctx = React.useContext(LeadsBrowserContext);
   if (!ctx) {
      throw new Error('useLeadsBrowser must be used inside LeadsBrowserProvider');
   }

   return ctx;
};
